export function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

export function isOdd(num) { return num % 2;}


// WEBPACK FOOTER //
// ./src/utils/misc.js